import { useParams } from 'react-router-dom';

import { useSelectedStore } from '@web/app/shared';

import { ProductListPage } from './ProductListPage';
import { ProjectListPage } from './ProjectListPage';
import { WorkspaceListPage } from './WorkspaceListPage';

export const WorkspaceProjectRouter = () => {
    const { workspaceId, projectId } = useParams<{ workspaceId: string; projectId: string }>();
    const { workspace, project } = useSelectedStore();

    if (!workspaceId || !workspace) {
        return <WorkspaceListPage />;
    }

    if (!projectId || !project) {
        return <ProjectListPage />;
    }

    return <ProductListPage />;
};

// Export as NewHomePage for backward compatibility
export { WorkspaceProjectRouter as NewHomePage };
